var hasDocument = typeof document === 'object' && document !== null;
var hasWindow = typeof window === 'object' && window !== null && window.self === window;
var isBrowser = function () { return hasDocument && hasWindow; };
export default isBrowser;
